import styled from "styled-components";

export const MainHeader = styled.header`
  display: flex;
  width: 100vw;
  height: 50px;
  padding: 0 16px;
  align-items: center;
  justify-content: space-between;
  background: ${(props) => props.theme.colors.white};
  border-bottom: 1px solid ${(props) => props.theme.colors.headerBorder};
  box-shadow: ${(props) => props.theme.shadow.header};
`;

export const HeadTit = styled.div`
  font-size: 1.8rem;
`;
